const THEME_PREFERENCES = ["light", "dark", "hc", "system"];
const THEME_STORAGE_KEY = "bf.theme";
const isThemePreference = (value) => typeof value === "string" && THEME_PREFERENCES.includes(value);
function loadThemePreference(storage) {
  try {
    const value = storage?.getItem(THEME_STORAGE_KEY);
    return isThemePreference(value) ? value : "system";
  } catch {
    return "system";
  }
}
function saveThemePreference(storage, preference) {
  try {
    storage?.setItem(THEME_STORAGE_KEY, preference);
    return storage !== void 0;
  } catch {
    return false;
  }
}
function resolveTheme(preference, signals = { prefersDark: false, prefersHighContrast: false }) {
  if (preference === "light") return "light";
  if (preference === "dark") return "dark";
  if (preference === "hc") return "highContrast";
  if (signals.prefersHighContrast) return "highContrast";
  return signals.prefersDark ? "dark" : "light";
}
export {
  THEME_PREFERENCES,
  THEME_STORAGE_KEY,
  isThemePreference,
  loadThemePreference,
  resolveTheme,
  saveThemePreference
};
//# sourceMappingURL=theme-preference.js.map